export default "__VITE_ASSET__c4cdfa8c__"